
import React, { useState } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from '@/hooks/use-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      toast({
        title: "تم إرسال الرسالة!",
        description: "سنتواصل معك في أقرب وقت ممكن."
      });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-16 page-container">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-autocare-blue mb-6">
            اتصل بنا
          </h1>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <div className="bg-white shadow-md rounded-lg p-6 mb-8">
                <h2 className="text-xl font-semibold text-autocare-blue mb-4">أرسل لنا رسالة</h2>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                      الاسم الكامل
                    </label>
                    <Input id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="اسمك" />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      البريد الإلكتروني
                    </label>
                    <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="your.email@example.com" />
                  </div>
                  
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                      الموضوع
                    </label>
                    <Input id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="كيف يمكننا مساعدتك؟" />
                  </div>
                  
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                      الرسالة
                    </label>
                    <Textarea id="message" name="message" value={formData.message} onChange={handleChange} required placeholder="رسالتك هنا..." rows={5} />
                  </div>
                  
                  <Button type="submit" className="w-full bg-autocare-blue hover:bg-autocare-blue-light text-white" disabled={isSubmitting}>
                    {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
                  </Button>
                </form>
              </div>
            </div>
            
            <div>
              <div className="bg-white shadow-md rounded-lg p-6 mb-8">
                <h2 className="text-xl font-semibold text-autocare-blue mb-4">موقعنا</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="font-medium text-gray-900">العنوان</h3>
                    <p className="text-gray-600 mx-0">نابلس، فلسطين</p>
                  </div>
                  
                  <div>
                    <h3 className="font-medium text-gray-900">البريد الإلكتروني</h3>
                    <p className="text-gray-600">autocarepalestine@gmail.com</p>
                  </div>
                  
                  <div>
                    <h3 className="font-medium text-gray-900">الهاتف</h3>
                    <p className="text-gray-600">0566752075</p>
                  </div>
                  
                  <div>
                    <h3 className="font-medium text-gray-900">ساعات العمل</h3>
                    <p className="text-gray-600">الأحد-الخميس: 9:00 ص - 6:00 م</p>
                    <p className="text-gray-600">السبت: 10:00 ص - 4:00 م</p>
                    <p className="text-gray-600">الجمعة: مغلق</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Contact;
